// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3m3Hg","form":"styles_form__3g2bl"};